"use client";

import React from "react";
import { UIUtils } from "@/shared/utils/UIUtils";
import { cn } from "../utils";
import { useAppLayerContext } from "../contexts/AppLayer";

type StickyPriceProps = {
    totalPrice: number;
    preDiscountPrice: number;
    billingFreqText: string;
};

export default function StickyPrice({ totalPrice, preDiscountPrice, billingFreqText }: StickyPriceProps) {
    const hasDiscount = preDiscountPrice > totalPrice;
    const { appState } = useAppLayerContext();
    const { partnerOffer } = appState;
    const formattedTotal = UIUtils.formatCurrency(totalPrice);
    const formattedBefore = UIUtils.formatCurrency(preDiscountPrice);

    return (
        <>
            <div
                className={cn(
                    "flex items-center gap-1 leading-4 text-content-brand-b-secondary sm:leading-5 sm:text-content-primary max-sm:dark:text-content-secondary",
                    partnerOffer && "text-content-success-invert"
                )}
            >
                <span className="hidden text-sm font-medium sm:block">Total:</span>
                {/* Final Price */}
                <span className="text-xs font-bold sm:text-base">
                    {formattedTotal}
                    <span className="text-xs font-medium sm:text-sm">/{billingFreqText}</span>
                </span>

                {/* Pre-discount price */}
                {hasDiscount && (
                    <span className={cn("hidden text-sm font-medium text-content-brand-b line-through sm:block", partnerOffer && "text-content-success")}>{formattedBefore}</span>
                )}
            </div>
        </>
    );
}
